import React, { useState, useEffect } from 'react';
import './Time2.css';

// List of countries with their timezone offsets from UTC
const countries = [
  { name: 'United States (New York)', offset: -10.5 },
  { name: 'Brazil (Brasilia)', offset: -8.5 },
  { name: 'United Kingdom (London)', offset: -5.5 },
  { name: 'Germany (Berlin)', offset: -4.5 },
  { name: 'South Africa (Johannesburg)', offset: -3.5 },
  { name: 'India (New Delhi)', offset: 0 },
  { name: 'China (Beijing)', offset: 2.5 },
  { name: 'Japan (Tokyo)', offset: 3.5 },
  { name: 'Australia (Sydney)', offset: 5.5 },
  { name: 'New Zealand (Wellington)', offset: 9 },
];

// Helper function to get the time in a specific timezone
const getTimeInTimezone = (offset) => {
  const utcTime = new Date();
  const localTime = new Date(utcTime.getTime() + offset * 60 * 60 * 1000);
  return localTime.toLocaleTimeString();
};

function Time2() {
  const [times, setTimes] = useState(countries.map(country => getTimeInTimezone(country.offset)));
  const [indiaTime, setIndiaTime] = useState(getTimeInTimezone(0));

  // Update time every second
  useEffect(() => {
    const intervalId = setInterval(() => {
      setTimes(countries.map(country => getTimeInTimezone(country.offset)));
      setIndiaTime(getTimeInTimezone(0)); // Update India time separately
    }, 1000);
    
    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className="AppTime2">
      <h1>World Clock</h1>
      <div className="clock-container">
        <div className="country-time">
          <h2>India (New Delhi)</h2>
          <p>{indiaTime}</p>
        </div>
        {countries.filter(country => country.name !== 'India (New Delhi)').map((country, index) => (
          <div key={country.name} className="country-time">
            <h2>{country.name}</h2>
            <p>{times[index]}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Time2;
